import styled from "styled-components";

export const Wrapper = styled.div`
    width: 100%;
    height: ${props => (props?.height ? props.height : "100%")};
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 0.5px solid #999d9a;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
`;

export const ProgressBar = styled.div`
    width: ${props => (props?.progress ? `${props.progress}%` : "0%")};
    height: 100%;
    position: relative;
    background-color: ${props => props?.backgroundColor};
`;
